export default "__VITE_PUBLIC_ASSET__b652700c__"